import { categoryData } from "../../../mocks/anime";

interface CategorySectionProps {
  onSelect: (tag: string) => void;
}

export default function CategorySection({ onSelect }: CategorySectionProps) {
  return (
    <section id="category" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 md:mb-10 md:flex-row md:items-end">
          <div>
            <p className="mb-2 text-xs font-bold tracking-widest text-primary-600">题材分类</p>
            <h2 className="font-display text-2xl text-foreground-950 md:text-4xl">
              按题材快速定位你的心头好
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              无论是后宫恋爱、逆后宫，还是暧昧攻略与高甜日常，点击分类即可一键筛出对味的女神动漫恋爱故事。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categoryData.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onSelect(cat.tag)}
              className="group relative h-64 overflow-hidden rounded-lg text-left lg:h-[380px]"
            >
              <img
                src={cat.image}
                alt={`${cat.name}题材动漫推荐`}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <span className="mb-2 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-bold text-white">
                  {cat.tag}
                </span>
                <h3 className="font-display text-lg text-white">{cat.name}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-white/80 line-clamp-2">
                  {cat.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-amber-300 opacity-0 transition-opacity group-hover:opacity-100">
                  查看该分类 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}